import KanvasCore, { genericAuthMiddleware } from "@kanvas/core";
import { setContext } from "@apollo/client/link/context";

const getKey = (): Promise<string | null> => {
  return new Promise((resolve) => {
    const key = localStorage.getItem("token");
    resolve(key);
  });
};

const AdminMiddleware = setContext((_, context) => {
  const headers = {
    ...context.headers,
    'X-Kanvas-Key': import.meta.env.VITE_KANVAS_ADMIN_KEY,
  }

  return { headers };
});

export const client = new KanvasCore({
  url: import.meta.env.VITE_KANVAS_API_URL,
  key: import.meta.env.VITE_KANVAS_API_KEY,
  middlewares: [genericAuthMiddleware(getKey)],
});

export const adminClient = new KanvasCore({
  url: import.meta.env.VITE_KANVAS_API_URL,
  key: import.meta.env.VITE_KANVAS_API_KEY,
  middlewares: [genericAuthMiddleware(getKey), AdminMiddleware],
});